import { Link } from 'react-router-dom';
import { useLang } from '../../../i18n/LanguageContext';

const courses = [
  {
    id: 1,
    icon: 'ri-magic-line',
    nameEn: 'Professional Tarot Course · Level I & II', nameZh: '专业塔罗课程 · 一阶&二阶',
    name: 'Professional Tarot Course · Level I & II',
    descEn: 'A complete path from beginner to professional tarot reader. Build your own reading system, master structured interpretation, and deliver clear, accurate insights for real clients.',
    descZh: '从初学者到专业塔罗师的完整修炼路径，建立您自己的解读体系，掌握结构化诠释方法，为真实客户提供清晰准确的洞见。',
    description: 'A complete path from beginner to professional tarot reader. Build your own reading system, master structured interpretation, and deliver clear, accurate insights for real clients.',
    durationEn: 'Online Course', durationZh: '线上课程',
    duration: 'Online Course',
    levelEn: 'Beginner to Pro', levelZh: '入门到专业',
    level: 'Beginner to Pro',
    outline: [
      { week: 'W1', title: 'Introduction to Tarot', titleZh: '塔罗牌入门', topics: ['History of Tarot', 'Major & Minor Arcana overview', 'Choosing your first deck'], topicsZh: ['塔罗牌历史', '大阿尔卡纳与小阿尔卡纳概述', '选择您的第一副牌组'] },
      { week: 'W2', title: 'Major Arcana Deep Dive', titleZh: '大阿尔卡纳深度解析', topics: ['The Fool\'s Journey', 'Colors and the Four Elements', 'Tarot Deck Activation Ritual'], topicsZh: ['愚者之旅', '色彩与四元素', '塔罗牌组激活仪式'] },
      { week: 'W3', title: 'Minor Arcana Mastery', titleZh: '小阿尔卡纳精通', topics: ['Four suits explained', 'Major Arcana In-Depth Study', 'Minor Arcana In-Depth Study'], topicsZh: ['四种花色详解', '大阿尔卡纳深度学习', '小阿尔卡纳深度学习'] },
      { week: 'W4', title: 'Spreads & Layouts', titleZh: '牌阵与排列', topics: ['Integrated Tarot Reading Techniques', 'Top 10 Common Tarot Spreads', 'Reversal Interpretation Overview'], topicsZh: ['综合塔罗解读技法', '十大常用塔罗牌阵', '逆位牌解读概述'] },
      { week: 'W5', title: 'Intuitive Reading', titleZh: '直觉解读', topics: ['Developing intuition', 'Timing Interpretation Techniques', 'Accuracy Enhancement Techniques'], topicsZh: ['直觉力培养', '时间解读技法', '准确率提升技巧'] },
      { week: 'W6', title: 'Advanced Techniques', titleZh: '高级技法', topics: ['In-Depth Guide to the Court Cards', 'Combining cards', 'Professional ethics'], topicsZh: ['宫廷牌深度指南', '牌与牌的结合解读', '职业解读伦理'] },
    ],
    objectives: [
      'Understand all 78 Tarot cards',
      'Perform accurate readings for others',
      'Develop personal intuition',
      'Master multiple spread layouts',
      'Apply ethical reading practices',
      'Build a professional reading practice',
    ],
    objectivesZh: [
      '掌握全部78张塔罗牌含义',
      '为他人进行准确的牌阵解读',
      '培养个人直觉力',
      '精通多种牌阵布局',
      '运用职业解读伦理准则',
      '建立专业解读实践体系',
    ],
  },
  {
    id: 2,
    icon: 'ri-planet-line',
    nameEn: 'Professional Astrology Course · Level I & II', nameZh: '专业占星课程 · 一阶&二阶',
    name: 'Professional Astrology Course · Level I & II',
    descEn: 'Learn how to read a birth chart and predict life cycles with clarity. From understanding core placements to interpreting transits and timing, you\'ll build a complete system for real-life guidance.',
    descZh: '学习清晰地解读星盘并预测人生周期，从核心星位的解析到行星过境与时机判断，建立一套完整的现实指引体系。',
    description: 'Learn how to read a birth chart and predict life cycles with clarity. From understanding core placements to interpreting transits and timing, you\'ll build a complete system for real-life guidance.',
    durationEn: 'Online Course', durationZh: '线上课程',
    duration: 'Online Course',
    levelEn: 'Advanced', levelZh: '进阶',
    level: 'Advanced',
    outline: [
      { week: 'W1', title: 'Foundations of Astrology', titleZh: '占星学基础', topics: ['Zodiac signs overview', 'Planets and their meanings', 'Houses explained'], topicsZh: ['黄道十二星座概述', '行星及其含义', '宫位详解'] },
      { week: 'W2', title: 'Reading Birth Charts', titleZh: '解读出生星盘', topics: ['Chart calculation', 'Ascendant & Midheaven', 'Planetary placements'], topicsZh: ['星盘计算方法', '上升点与天顶解析', '行星位置解读'] },
      { week: 'W3', title: 'Aspects & Transits', titleZh: '相位与行星过境', topics: ['Major aspects', 'Transit interpretation', 'Predictive astrology'], topicsZh: ['主要相位解析', '过境解读技法', '预测占星学'] },
      { week: 'W4', title: 'Synastry & Compatibility', titleZh: '合盘与配对分析', topics: ['Relationship charts', 'Composite charts', 'Compatibility analysis'], topicsZh: ['关系星盘', '合成星盘', '相容性分析'] },
    ],
    objectives: [
      'Read and interpret birth charts',
      'Understand planetary influences',
      'Analyze relationship compatibility',
      'Predict life trends with transits',
    ],
    objectivesZh: [
      '解读并分析出生星盘',
      '理解行星影响力',
      '分析人际关系配对',
      '通过行星过境预测人生趋势',
    ],
  },
  {
    id: 3,
    icon: 'ri-flask-line',
    nameEn: 'Practical Herbal Magic Course · Level I & II', nameZh: '实用草药魔法课程 · 一阶&二阶',
    name: 'Practical Herbal Magic Course · Level I & II',
    descEn: 'Learn the foundations of magical herbs and how they actually work in practice. From core theory to hands-on creation, you\'ll craft your own ritual tools — including candles, oils, sachets, and more.',
    descZh: '学习魔法草药的核心知识及其实际运用，从基础理论到亲手制作，您将自制仪式工具——包括蜡烛、精油、香囊等。',
    description: 'Learn the foundations of magical herbs and how they actually work in practice. From core theory to hands-on creation, you\'ll craft your own ritual tools — including candles, oils, sachets, and more.',
    durationEn: 'Online Course', durationZh: '线上课程',
    duration: 'Online Course',
    levelEn: 'Certified', levelZh: '认证级',
    level: 'Certified',
    outline: [
      { week: 'W1', title: 'Herbal Magic Basics', titleZh: '草药魔法基础', topics: ['The Magical World & Origins of Herbal Magic', 'Knowing & Sensing Plants', 'Harvesting & storing methods', 'Energy altars & spells', 'Energy charging techniques', 'Holy water preparation', 'Harnessing sun, moon, stars & seasons', 'Special herb usage & taboos', 'Green magic initiation'], topicsZh: ['魔法世界与草药魔法起源', '认识植物与感知植物', '采集与保存方法', '能量祭坛与咒语', '能量充能技法', '圣水的制备', '利用日月星辰与四季', '特殊草药的使用禁忌和用途', '绿魔法初践'] },
      { week: 'W2', title: 'Potion Brewing', titleZh: '魔法药剂酿造', topics: ['Categories of potions & energy carriers', 'Recipe structure & potion design', 'Basic alchemy: herbal principles & practice', 'Activation methods & usage'], topicsZh: ['魔法药剂的分类与能量载体', '配方结构与药剂设计', '草药炼金术原理与实践', '激活方式与使用方法'] },
      { week: 'W3', title: 'Aromatic Formulas', titleZh: '芳香仪式配方', topics: ['Magic sachet making', 'Essential oil blending', 'Incense crafting', 'Ritual perfumes'], topicsZh: ['魔法香囊制作', '精油调配技法', '熏香制作工艺', '仪式香水配制'] },
      { week: 'W4', title: 'Magic Candle Crafting', titleZh: '魔法蜡烛制作', topics: ['Candle color magic', 'Herb & crystal infusion', 'Intention setting', 'Ritual candle blessing'], topicsZh: ['蜡烛颜色魔法对应', '草药与水晶融入技法', '意图注入与充能', '仪式蜡烛祝圣方法'] },

    ],
    objectives: [
      'Identify and work with 100+ magical herbs',
      'Brew effective energy potions',
      'Create aromatic ritual formulas',
      'Craft energy-charged magical candles',
    ],
    objectivesZh: [
      '识别并运用100+种魔法草药',
      '酿制有效的能量药剂',
      '创制芳香仪式配方',
      '制作有能量的魔法蜡烛',
    ],
  },
  {
    id: 4,
    icon: 'ri-sparkling-line',
    nameEn: 'Crystal & Chakra Healing Course', nameZh: '水晶&脉轮疗愈课程',
    name: 'Crystal & Chakra Healing Course',
    descEn: 'Learn how to work with crystals through the chakra system. Understand energy centers, how imbalance shows up in real life, and how to use crystals to restore flow, stability, and emotional balance.',
    descZh: '通过脉轮系统学习运用水晶，了解能量中心与失衡表现，掌握如何用水晶恢复能量流动、内在稳定与情绪平衡。',
    description: 'Learn how to work with crystals through the chakra system. Understand energy centers, how imbalance shows up in real life, and how to use crystals to restore flow, stability, and emotional balance.',
    durationEn: 'Online Course', durationZh: '线上课程',
    duration: 'Online Course',
    levelEn: 'Beginner', levelZh: '入门',
    level: 'Beginner',
    outline: [
      { week: 'W1', title: 'Crystal Fundamentals', titleZh: '水晶基础知识', topics: ['Crystal formation & types', 'Vibrational properties', 'Cleansing methods'], topicsZh: ['水晶的形成与类型', '振动属性解析', '水晶净化方法'] },
      { week: 'W2', title: 'Chakra Healing', titleZh: '脉轮疗愈', topics: ['Seven chakra system', 'Crystal-chakra mapping', 'Balancing sessions'], topicsZh: ['七脉轮系统详解', '水晶与脉轮对应关系', '脉轮平衡疗程实操'] },
      { week: 'W3', title: 'Healing Layouts', titleZh: '疗愈水晶布局', topics: ['Body grid layouts', 'Space clearing grids', 'Protective arrangements'], topicsZh: ['身体水晶网格布局', '空间净化网格设计', '防护水晶排列'] },
      { week: 'W4', title: 'Advanced Practice', titleZh: '高阶水晶实践', topics: ['Crystal elixirs', 'Programming crystals', 'Client sessions'], topicsZh: ['水晶精华液制作', '水晶意图编程', '专业客户疗程'] },
    ],
    objectives: [
      'Identify 50+ healing crystals',
      'Perform chakra balancing sessions',
      'Create powerful crystal grids',
      'Conduct professional healing sessions',
    ],
    objectivesZh: [
      '识别50+种疗愈水晶',
      '进行专业脉轮平衡疗程',
      '创建强效水晶能量网格',
      '开展专业水晶疗愈服务',
    ],
  },
  {
    id: 5,
    icon: 'ri-moon-line',
    nameEn: 'Lunar Magic Course · Ritual Practice', nameZh: '月相魔法课程 · 仪式实践',
    name: 'Lunar Magic Course · Ritual Practice',
    descEn: 'Learn to work with lunar phases through simple, powerful rituals. Know when to act, when to release, and how to align your intentions with the cycle.',
    descZh: '通过简单而有力的仪式学习运用月相能量，掌握行动与释放的时机，将意图与月相周期完美对齐。',
    description: 'Learn to work with lunar phases through simple, powerful rituals. Know when to act, when to release, and how to align your intentions with the cycle.',
    durationEn: 'In-Person Course', durationZh: '面授课程',
    duration: 'In-Person Course',
    levelEn: 'Practical', levelZh: '实践',
    level: 'Practical',
    outline: [
      { week: 'W1', title: 'Lunar Cycle Basics', titleZh: '月相周期基础', topics: ['Eight moon phases', 'Lunar calendar reading', 'Moon in zodiac signs'], topicsZh: ['八种月相详解', '月历解读方法', '月亮所在星座'] },
      { week: 'W2', title: 'New Moon Rituals', titleZh: '新月仪式', topics: ['Intention setting', 'Manifestation spells', 'New moon journaling'], topicsZh: ['新月意图设定', '显化魔法仪式', '新月日记书写'] },
      { week: 'W3', title: 'Full Moon Practices', titleZh: '满月实践', topics: ['Release ceremonies', 'Charging tools', 'Full moon meditation'], topicsZh: ['满月释放仪式', '工具充能方法', '满月冥想引导'] },
      { week: 'W4', title: 'Advanced Lunar Magic', titleZh: '高级月相魔法', topics: ['Eclipse work', 'Lunar gardening', 'Moon water magic'], topicsZh: ['日月食能量工作', '月亮园艺实践', '月亮水魔法'] },
    ],
    objectives: [
      'Track and work with all moon phases',
      'Perform new moon manifestation rituals',
      'Conduct full moon release ceremonies',
      'Align daily life with lunar cycles',
    ],
    objectivesZh: [
      '追踪并运用所有月相能量',
      '进行新月显化仪式',
      '举行满月释放仪式',
      '将日常生活与月相周期对齐',
    ],
  },
  {
    id: 6,
    icon: 'ri-book-open-line',
    nameEn: 'Runic Course · Symbols & Practice', nameZh: '北欧符文课程 · 符号与实践',
    name: 'Runic Course · Symbols & Practice',
    descEn: 'Learn to read and work with runes beyond simple meanings. Understand how each symbol carries direction and use them for clear guidance and real-life decisions.',
    descZh: '超越简单含义地解读和运用符文，理解每个符号所蕴含的方向，将其应用于清晰的指引和现实决策中。',
    description: 'Learn to read and work with runes beyond simple meanings. Understand how each symbol carries direction and use them for clear guidance and real-life decisions.',
    durationEn: 'Online Course', durationZh: '线上课程',
    duration: 'Online Course',
    levelEn: 'Advanced', levelZh: '进阶',
    level: 'Advanced',
    outline: [
      { week: 'W1', title: 'Runic System', titleZh: '卢恩符文体系', topics: ['24 runes overview', 'Historical origins', 'Rune carving basics'], topicsZh: ['24个符文概述', '历史起源考证', '符文刻写基础'] },
      { week: 'W2', title: 'Rune Meanings', titleZh: '符文含义精解', topics: ['Individual rune study', 'Reversed meanings', 'Elemental associations'], topicsZh: ['逐个符文深度研习', '逆位含义解析', '元素对应关系'] },
      { week: 'W3', title: 'Casting Methods', titleZh: '符文投掷方法', topics: ['Rune Draw', 'Rune Spread', 'Rune Casting'], topicsZh: ['符文抽取', '符文牌阵', '符文投掷法'] },
      { week: 'W4', title: 'Runic Magic', titleZh: '符文魔法实践', topics: ['Bind Runes', 'Runic Talismans', 'Chanting Spells'], topicsZh: ['绑定符文制作', '符文护符设计', '吟唱咒语'] },
    ],
    objectives: [
      'Master all 24 Elder Futhark runes',
      'Perform accurate rune readings',
      'Create powerful bind runes',
      'Apply runic magic in daily practice',
    ],
    objectivesZh: [
      '精通全部24个古老符文',
      '进行准确的符文占卜解读',
      '创制强效绑定符文',
      '在日常生活中运用符文魔法',
    ],
  },
  {
    id: 7,
    icon: 'ri-fire-line',
    nameEn: 'Energy Reset & Touch Healing Course', nameZh: '能量重置与触感疗愈课程',
    name: 'Energy Reset & Touch Healing Course',
    descEn: 'Guide the body into stillness through touch. Learn how to work with key points and attention to release tension, quiet the mind, and reset the inner state.',
    descZh: '通过触碰引导身体进入静止状态，运用关键穴位与专注力释放紧张感，平静思绪并重置内在状态。',
    description: 'Guide the body into stillness through touch. Learn how to work with key points and attention to release tension, quiet the mind, and reset the inner state.',
    durationEn: 'In-Person Course', durationZh: '面授课程',
    duration: 'In-Person Course',
    levelEn: 'Certified', levelZh: '认证级',
    level: 'Certified',
    outline: [
      { week: 'W1', title: 'Energy System Foundations & Perception Awakening', titleZh: '能量系统基础与感知开启', topics: ['Human energy structure & consciousness layers', 'Energy storage & release', 'Principles of touch healing', 'Energy perception training'], topicsZh: ['人体能量结构与意识层', '能量的储存与释放', '触感疗愈的原理', '能量感知训练'] },
      { week: 'W2', title: 'Touch Point System & Energy Release Logic', titleZh: '触点系统与能量释放逻辑', topics: ['Structure & distribution of energy touch points', 'Consciousness domains of touch points', 'Identifying blockages & overload states', 'Touch guidance & safety boundaries'], topicsZh: ['能量触点的基础结构与分布', '不同触点对应的意识领域', '如何识别阻滞与过载状态', '触感引导与安全边界'] },
      { week: 'W3', title: 'Practical Techniques & Session Building', titleZh: '实操手法与流程建立', topics: ['Standard touch healing flow', 'Rhythm & pressure control', 'Solo practice & partner practicum', 'Common issue handling'], topicsZh: ['标准触感流程', '手法节奏与力度控制', '单人练习与双人实操', '常见问题处理'] },
      { week: 'W4', title: 'Energy Reset & Integration', titleZh: '能量重置与整合应用', topics: ['Building a complete healing session', 'Applications for different goals', 'Integration with other healing systems'], topicsZh: ['一次完整疗愈流程搭建', '不同目标的应用', '与其他疗愈系统结合'] },
    ],
    objectives: [
      'Understand human energy structure and touch point system',
      'Identify blockages, overload states and their underlying logic',
      'Execute a complete standard touch healing session independently',
      'Apply touch healing techniques for different goals and contexts',
      'Integrate touch healing with other energy healing systems',
    ],
    objectivesZh: [
      '理解人体能量结构与触点系统',
      '识别阻滞与过载状态及其底层逻辑',
      '独立完成一次完整的标准触感疗愈流程',
      '针对不同目标灵活运用触感疗愈手法',
      '将触感疗愈与其他疗愈系统结合应用',
    ],
  },
  {
    id: 8,
    icon: 'ri-compass-3-line',
    nameEn: 'Intuitive Sight & Communication', nameZh: '灵视觉与灵性沟通课程',
    name: 'Intuitive Sight & Communication',
    descEn: 'Learn to open your inner vision and develop perception beyond the physical. Includes training in intuitive sight, animal communication, and communication with non-physical beings.',
    descZh: '学习开启灵视力，发展超越物质层面的感知能力，涵盖直觉视觉、动物沟通及与非物质存在交流的训练。',
    description: 'Learn to open your inner vision and develop perception beyond the physical. Includes training in intuitive sight, animal communication, and communication with non-physical beings.',
    durationEn: 'Online Course', durationZh: '线上课程',
    duration: 'Online Course',
    levelEn: 'Advanced', levelZh: '进阶',
    level: 'Advanced',
    outline: [
      { week: 'W1', title: 'Perception Mechanisms & Consciousness Foundations', titleZh: '感知机制与意识基础', topics: ['What is "channeling"', 'Brain & intuition relationship', 'Opening spiritual perception channels', 'Distinguishing "perception" from "imagination"'], topicsZh: ['什么是"通灵"', '大脑与直觉的关系', '灵性感知通道开启', '如何区分"感知"与"想象"'] },
      { week: 'W2', title: 'Foundational Remote Viewing Training', titleZh: '遥视的基础训练', topics: ['Principles & information reception methods', 'Basic practice: information reading', 'Methods to improve accuracy'], topicsZh: ['遥视的原理与信息接收方式', '基础练习：信息读取', '提高准确度的方法'] },
      { week: 'W3', title: 'Animal Communication Training', titleZh: '动物沟通训练', topics: ['Establishing connection with animals', 'Basic communication practice', 'Avoiding common misconceptions'], topicsZh: ['如何建立与动物的连接', '基础沟通练习', '常见误区避免'] },
      { week: 'W4', title: 'Non-Physical Consciousness Connection', titleZh: '非物理意识连接（亡灵沟通）', topics: ['Consciousness residue & information fields', 'Risk identification & self-protection', 'Receiving & verifying information'], topicsZh: ['什么是意识残留与信息场', '风险识别与自我保护', '信息的接收与验证方式'] },
    ],
    objectives: [
      'Understand spiritual perception mechanisms and distinguish real perception from imagination',
      'Master foundational remote viewing principles and information reception methods',
      'Establish conscious connection with animals and conduct basic communication',
      'Identify risks in non-physical consciousness connection and apply self-protection',
      'Accurately receive and verify information across different awareness dimensions',
    ],
    objectivesZh: [
      '理解灵性感知机制，区分真实感知与想象',
      '掌握遥视的基础原理与信息读取方法',
      '建立与动物的意识连接并进行基础沟通',
      '识别非物理意识连接的风险并进行自我保护',
      '正确接收与验证来自不同维度的信息',
    ],
  },
];

export default function Courses() {
  const { t } = useLang();
  return (
    <section id="courses" className="py-24 px-4 sm:px-8 bg-gradient-to-b from-[#1a0b2e] via-[#2d1b4e] to-[#1a0b2e] relative overflow-hidden">
      {/* 全局动画样式 */}
      <style>{`
        @keyframes borderGlow {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 1; }
        }
        @keyframes rotateBorder {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes pulseGlow {
          0%, 100% { box-shadow: 0 0 8px 2px rgba(212,175,55,0.15), 0 0 20px 4px rgba(212,175,55,0.08); }
          50% { box-shadow: 0 0 20px 6px rgba(212,175,55,0.45), 0 0 40px 12px rgba(212,175,55,0.2), 0 0 60px 20px rgba(212,175,55,0.08); }
        }
        .course-card {
          position: relative;
          transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
        }
        .course-card::before {
          content: '';
          position: absolute;
          inset: -1px;
          border-radius: 1rem;
          padding: 1px;
          background: linear-gradient(135deg, transparent 0%, rgba(212,175,55,0.1) 50%, transparent 100%);
          -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          opacity: 0;
          transition: opacity 0.4s ease;
          pointer-events: none;
        }
        .course-card::after {
          content: '';
          position: absolute;
          inset: -1px;
          border-radius: 1rem;
          background: conic-gradient(
            from var(--angle, 0deg),
            transparent 0deg,
            rgba(212,175,55,0.8) 60deg,
            rgba(244,208,63,1) 90deg,
            rgba(212,175,55,0.8) 120deg,
            transparent 180deg,
            transparent 360deg
          );
          -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          padding: 1.5px;
          opacity: 0;
          transition: opacity 0.4s ease;
          pointer-events: none;
        }
        @property --angle {
          syntax: '<angle>';
          initial-value: 0deg;
          inherits: false;
        }
        @keyframes spinAngle {
          to { --angle: 360deg; }
        }
        .course-card:hover::after {
          opacity: 1;
          animation: spinAngle 2.5s linear infinite;
        }
        .course-card:hover::before {
          opacity: 1;
        }
        .course-card:hover {
          animation: pulseGlow 2s ease-in-out infinite;
          transform: translateY(-8px);
          border-color: rgba(212,175,55,0.6) !important;
        }
        .course-card .glow-inner {
          position: absolute;
          inset: 0;
          border-radius: 1rem;
          background: radial-gradient(ellipse at 50% 0%, rgba(212,175,55,0.12) 0%, transparent 70%);
          opacity: 0;
          transition: opacity 0.5s ease;
          pointer-events: none;
        }
        .course-card:hover .glow-inner {
          opacity: 1;
        }
        .course-card .icon-wrap {
          transition: all 0.4s ease;
        }
        .course-card:hover .icon-wrap {
          box-shadow: 0 0 20px 6px rgba(212,175,55,0.35);
          background: rgba(212,175,55,0.2);
          transform: scale(1.1);
        }
        .course-card:hover .icon-wrap i {
          text-shadow: 0 0 12px rgba(212,175,55,0.9);
        }
      `}</style>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-[#d4af37] via-[#c8b6ff] to-[#d4af37] bg-clip-text text-transparent">
            Transformative Courses
          </h2>
          <p className="text-xl text-[#c8b6ff]">{t('A structured learning path from beginner to mastery', '从入门到精通的系统学习路径')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {courses.map((course, index) => (
            <div
              key={index}
              className="course-card group relative bg-white/5 backdrop-blur-sm rounded-2xl p-5 sm:p-8 hover:shadow-2xl transition-all duration-500 cursor-pointer border border-[#d4af37]/20 hover:-translate-y-2 overflow-hidden flex flex-col"
            >
              {/* 顶部内发光 */}
              <div className="glow-inner"></div>
              {/* 渐变背景叠加 */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#d4af37]/0 to-[#d4af37]/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl pointer-events-none"></div>

              <div className="relative z-10 flex flex-col flex-1">
                <div className="icon-wrap w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-gradient-to-br from-[#d4af37]/20 to-[#c8b6ff]/20 flex items-center justify-center mb-6 mx-auto group-hover:scale-110 group-hover:shadow-[0_0_30px_rgba(251,191,36,0.6)] transition-all duration-500 relative overflow-hidden flex-shrink-0">
                  <i className={`${course.icon} text-4xl text-[#d4af37]`}></i>
                </div>
                <h3 className="text-xl font-bold text-white text-center mb-3 min-h-[2rem] flex items-center justify-center">{t(course.nameEn, course.nameZh)}</h3>
                <p className="text-[#c8b6ff] text-center mb-6 leading-relaxed text-sm flex-1">{t(course.descEn, course.descZh)}</p>
                <div className="flex items-center justify-center space-x-2 mb-6 flex-wrap gap-y-2 flex-shrink-0">
                  <span className="px-3 py-1 bg-[#d4af37]/15 text-[#d4af37] text-xs rounded-full border border-[#d4af37]/30 whitespace-nowrap">{t(course.durationEn, course.durationZh)}</span>
                </div>
                <Link
                  to={`/course/${course.id}`}
                  className="block w-full py-3 border border-[#d4af37]/50 text-[#d4af37] rounded-lg hover:bg-gradient-to-r hover:from-[#d4af37] hover:to-[#f4d03f] hover:text-white hover:border-transparent transition-all duration-300 cursor-pointer whitespace-nowrap font-medium text-center text-sm flex-shrink-0"
                >
                  {t('View Details', '查看详情')}
                </Link>
              </div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-[#d4af37]/5 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export { courses };
